/* SatyShiv cart page. The quantity buttons step the updates[] input and submit the cart form (POST /cart), so the
   page, the drawer and the badge all re-render from the server. ss-main.js keeps its own cart cache private, which
   is why this never calls /cart/change.js behind its back. When the drawer changes the cart while the page is open
   (its steppers post /cart/change.js and re-render only the drawer), the page reloads as the drawer closes, so the
   updates[] inputs and the Checkout button never carry stale quantities. */
(function () {
  var page = document.querySelector('[data-sec="cartpage"]'); if (!page) return;
  var known = page.getAttribute('data-count') || '0', badge = document.querySelector('[data-cart-count]'), drawer = document.querySelector('[data-sec="drawer"]'), dirty = false;
  if (window.MutationObserver && badge && drawer) {
    new MutationObserver(function () { if (badge.textContent.trim() !== known) dirty = true; }).observe(badge, { childList: true, characterData: true, subtree: true });
    new MutationObserver(function () { if (dirty && drawer.getAttribute('aria-hidden') === 'true') window.location.reload(); }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  var form = page.querySelector('[data-ss-cart]'); if (!form) return;
  var upd = form.querySelector('[data-cart-update]'); if (upd) upd.hidden = true;
  function submit() { form.classList.add('is-busy'); if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
  form.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cart-step]'); if (!b) return;
    e.preventDefault();
    var inp = b.parentNode.querySelector('input[name="updates[]"]'); if (!inp) return;
    var q = (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-cart-step'), 10);
    inp.value = Math.max(0, q); submit();
  });
  form.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="updates[]"]')) submit();
  });
})();
